import { ScoopButton, ScoopTable, ScoopDialog } from '../../../../ui'
import { useMemo, useCallback } from 'react'
import styles from './PickColumns.module.scss'

export const PickColumns = ({
    pickColumnsDialogOpen,
    setPickColumnsDialogOpen,
    setSelectedFields,
    dialogSelectedFields,
    setDialogSelectedFields,
    targetColumn,
    fieldList,
}) => {
    const columnDefs = useMemo(
        () => [
            {
                field: 'value',
                header: 'Column',
                flex: 1,
                sortable: false,
                checkboxSelection: true,
                headerCheckboxSelection: true,
            },
        ],
        []
    )

    const isRowSelectable = useCallback((row) => row.id !== targetColumn, [targetColumn])

    const handleSelectionChange = useCallback(
        (selectedRows) => {
            const selectedIds = selectedRows.map((row) => row.id)
            setDialogSelectedFields(selectedIds)
        },
        [setDialogSelectedFields]
    )

    const handleGridReady = useCallback(
        (event) => {
            if (dialogSelectedFields?.length > 0) {
                event.api.forEachNode((node) => {
                    if (dialogSelectedFields.includes(node.data.id)) {
                        node.setSelected(true)
                    }
                })
            }
        },
        [dialogSelectedFields]
    )

    return (
        <ScoopDialog
            maxWidth="lg"
            open={pickColumnsDialogOpen}
            title={`Select columns to consider during analysis`}
            onClose={() => {
                setPickColumnsDialogOpen(false)
            }}
            actions={
                <>
                    <ScoopButton
                        variant="text"
                        size="sm"
                        onClick={() => {
                            setPickColumnsDialogOpen(false)
                        }}
                    >
                        Cancel
                    </ScoopButton>
                    <ScoopButton
                        variant="default"
                        size="sm"
                        onClick={() => {
                            setSelectedFields(dialogSelectedFields)
                            setPickColumnsDialogOpen(false)
                        }}
                    >
                        Save
                    </ScoopButton>
                </>
            }
        >
            <div className={styles.dialogContent}>
                <div className={styles.gridContainer}>
                    <ScoopTable
                        columns={columnDefs}
                        rows={fieldList}
                        selection={{
                            mode: 'multiple',
                            isRowSelectable,
                            onSelectionChange: handleSelectionChange,
                        }}
                        rowHeight={32}
                        headerHeight={40}
                        pagination={{
                            enabled: true,
                            pageSize: 10,
                        }}
                        emptyMessage="No columns available"
                        onGridReady={handleGridReady}
                    />
                </div>
            </div>
        </ScoopDialog>
    )
}
